var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C5.70625 1.375 1.375 5.70625 1.375 11C1.375 16.2937 5.70625 20.625 11 20.625C16.2937 20.625 20.625 16.2937 20.625 11C20.625 5.70625 16.2937 1.375 11 1.375ZM9.625 14.7812L6.1875 11.3438L7.2875 10.3125L9.625 12.65L14.7125 7.5625L15.8125 8.6625L9.625 14.7812Z",
    fill: "#2D91E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickCircle);
export default __webpack_public_path__ + "static/media/icon-tick-circle.f7dc8c1dcc92cb43e8dfc1417d8d88a7.svg";
export { ForwardRef as ReactComponent };